module.exports = __webpack_public_path__ + "img/item_mortal_city.e3fff992.png";